import { useEffect, useState } from "react";
import { ErrorContext } from "../../utils/context/error";
import { getConsultAll } from "../../services/office";
import IconM from "../dashboard/menu/icons/Icon";
import OfficeModal from "./officemodal";
import useTable from "../../hooks/table";
import TableFooter from "../../hooks/table/footer";


function OfficeView() {
  const [area, setArea] = useState([]);
  const [tbOffice, setOffice] = useState([]);
  const { setShowToast, setOpciones } = ErrorContext();
  // const { setRuta } = BreadContext();
  const [AreaId, setAreaId] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  
  const [AreaFId, setAreaFId] = useState(0);
  const [ConsultId, setConsultId] = useState(0);
  const [showM, setShowM] = useState(false);
  const [tag, setTag] = useState(0);
  const [page, setPage] = useState(1);
  const { slice, range } = useTable(tbOffice, page, 10);  
  
  //const [estado, setEstado] = useState("AC");
  //const [fileSelect, setfileSelect] = useState("");
    
  // Metodo para mostrar las areas en la grilla
  const fillConsult = async () => 
    {
       setShowToast(false);
       const response = await getConsultAll();
       if (response)
        {
           if (response.status === 200) 
            {
               //setArea(response.data.area);
               setOffice(response.data.data);
            } 
           else 
           {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
           }
        }
        else 
           {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
           }
    };
   // Boton Crear - Editar - Eliminar 
   const handleCrearConsult = (tagId) => 
     {
         if ((selectedRow === null) && (tagId !== 0)) return
         if (tagId === 0) 
         {
           setConsultId(0);
           setAreaId(AreaFId);
         }
          
         setShowM(true);
         setTag(tagId);
     };
   
    // al dar click en la fila
    const handlefilas = (Item, index) => 
      {
         setSelectedRow(index);
         setConsultId(Item.ConsultId);
         setAreaId(Item.AreaId);
      };
    
  // Filtrar por area
    const handleFiltrar =async(area) =>
      {
         let response=[];
         setAreaFId(area);
         if (area ===0) 
           response = await getConsultAll()
         else 
         { 
           //response = await getServicioAllxArea(area);
         }  
        if (response) 
          {
             if (response.status === 200) 
              {
                 setOffice(response.data.data);
              } 
             else 
             {
                 const Mensaje = response.message;
                 const opc = { type: "Danger", message: Mensaje, active: true };
                 setOpciones(opc);
                 setShowToast(true);
             }
          }         
      }
  
    //Llamada al iniciar
    useEffect(() => 
      {
         //setRuta("Administración / Digiturno / Servicios");
          setShowM(false);
          fillConsult();
      }, []);

  return (
    <>
      <div className="">
        <div className="paneltitle">
          <label className="text-[1.0rem] font-light text-gray-400 leading-none"> Administración/Digiturno/Consultorios</label>
        </div>
      
        <div className="panelmenu">
            <button className="btnmenu" onClick={() => handleCrearConsult(0)} >
              <IconM svg="newfile" className="iconmenu" title="newfile" />
              <span>Nuevo</span>
            </button>
            
            <button className="btnmenu" id="Editar" disabled={selectedRow === null} onClick={() => handleCrearConsult(1)}>
              <IconM svg="pencil" className="iconmenu" title="pencil" />
              <span>Editar</span>
            </button>
       
            <button className="btnmenu" id="Eliminar" onClick={() => handleCrearConsult(2)} disabled={selectedRow === null}>
              <IconM svg="delfile" className="iconmenu" title="delfile" />
              <span>Eliminar</span>
            </button>
  
          </div>
          <div className="mt-2 rounded-lg border border-stone-200 overflow-x-auto">
           <table className="w-full table-auto ">
               <thead className="border-b border-stone-200 text-sm font-medium ">
                 <tr>
                   <th className="px-2.5 py-2 text-start font-medium">Id.</th>
                   <th className="px-2.5 py-2 text-start font-medium">Código</th>
                   <th className="px-2.5 py-2 text-start font-medium">Consultorio</th>
                   <th className="px-2.5 py-2 text-start font-medium">Area</th>
                 </tr>
               </thead>
               <tbody className="group text-sm text-stone-800 ">
                {slice.map((item, index) => {
                     return (
                       <tr className={`border-b border-stone-200 last:border-0 ${selectedRow === index ? 'bg-blue-50 selected cursor-pointer' : ''}`} key={index} id={`fila${item.ConsultID}`} onClick={() => handlefilas(item, index)}>
                         <td>
                           <div className="flex w-full pl-1 gap-3 text-sm text-current">
                             {item.ConsultId}
                           </div>
                         </td>
                         <td>{item.CodConsult}</td>
                         <td>{item.NombConsult}</td>
                         <td>{item.NombreArea}</td>
                       </tr>
                  )})}
                 
               </tbody>
             </table>
             </div>
             <TableFooter range={range} slice={slice} setPage={setPage} page={page} /> 
       </div>
      <OfficeModal
        show={showM}
        AreaI={AreaId}
        AreaFId ={AreaFId}
        ConsultI={ConsultId}
        Tag={tag}
        handleshow={setShowM}
        handleFiltrar={handleFiltrar}
      ></OfficeModal>

    </>
  );
}
export default OfficeView;
